<script>
    import { isMobile } from "@/utils";

    export default {
        name: "PromocodeSteps",
        mounted() {
            if (!isMobile()) {
                let arrVideo = [
                    ".js-loading-video-1",
                    ".js-loading-video-2",
                    ".js-loading-video-3",
                ];
                arrVideo.forEach((className, i) => {
                    let src = `/static/xd-design/promocode/video/step_${i + 1}_dsktp.mp4`;
                    let video = document.querySelector(`${className}`);
                    let source = video.querySelector("source");
                    source.setAttribute("src", src);
                    video.load();
                });
            }
        },
    };
</script>

<template>
    <div class="promocode-steps">
        <h2 class="promocode-steps__title promocode__title">
            <span>Как применить промокод</span> на сайте XD Design
        </h2>

        <div class="promocode-steps__list">
            <div class="promocode-step promocode-step--1">
                <div class="promocode-step__text">
                    <img
                        class="promocode-step__number"
                        src="/static/xd-design/promocode/number_1.png"
                    />

                    <div class="promocode-step__desc">
                        Добавьте понравившийся рюкзак в корзину
                    </div>
                </div>
                <div class="promocode-step__block">
                    <video
                        loop
                        autoplay
                        playsinline
                        muted
                        class="promocode-step__video js-loading-video-1"
                    >
                        <source
                            src="/static/xd-design/promocode/video/step_1_mbl.mp4"
                            type="video/mp4"
                        />
                    </video>
                </div>
            </div>

            <div class="promocode-step promocode-step--2">
                <div class="promocode-step__text">
                    <img
                        class="promocode-step__number"
                        src="/static/xd-design/promocode/number_2.png"
                    />

                    <div class="promocode-step__desc">
                        Перейдите в корзину и введите промокод в специальном поле
                    </div>
                </div>
                <div class="promocode-step__block">
                    <video
                        loop
                        autoplay
                        playsinline
                        muted
                        class="promocode-step__video js-loading-video-2"
                    >
                        <source
                            src="/static/xd-design/promocode/video/step_2_mbl.mp4"
                            type="video/mp4"
                        />
                    </video>
                </div>
            </div>

            <div class="promocode-step promocode-step--3">
                <div class="promocode-step__text">
                    <img
                        class="promocode-step__number"
                        src="/static/xd-design/promocode/number_3.png"
                    />

                    <div class="promocode-step__desc">
                        Если промокод указан верно, стоимость заказа будет пересчитана с учетом
                        скидки
                    </div>
                </div>
                <div class="promocode-step__block">
                    <video
                        loop
                        autoplay
                        playsinline
                        muted
                        class="promocode-step__video js-loading-video-3"
                    >
                        <source
                            src="/static/xd-design/promocode/video/step_3_mbl.mp4"
                            type="video/mp4"
                        />
                    </video>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .promocode-steps {
        max-width: 500px;
        margin: 40px auto 76px;

        @include bp($bp-desktop-sm) {
            max-width: 1040px;
            margin-top: 80px;
            margin-bottom: 145px;
        }
    }

    .promocode-steps__title {
        margin-bottom: 32px;
        text-align: left;
        position: relative;
        z-index: 4;
        max-width: 312px;

        @include bp($bp-tablet-md) {
            max-width: 100%;
        }

        @include bp($bp-desktop-sm) {
            text-align: center;
            margin-bottom: 72px;
        }
    }

    .promocode-step {
        position: relative;

        @include bp($bp-desktop-sm) {
            display: flex;
            justify-content: flex-start;
        }

        &:not(:first-child) {
            margin-top: 96px;
        }
    }

    .promocode-step__text {
        position: relative;
        display: flex;
        margin-bottom: 20px;

        @include bp($bp-desktop-sm) {
            margin-bottom: 0;
        }
    }

    .promocode-step__block {
        position: relative;
        max-width: 404px;

        @include bp($bp-desktop-sm) {
            max-width: 100%;
        }

        &:after {
            content: "";
            position: absolute;
            width: 100%;
            height: 100%;
            background: var(--primary);
            bottom: -5px;
            right: -5px;
        }
    }

    .promocode-step__video {
        display: block;
        max-width: 100%;
        position: relative;
        z-index: 5;

        @include bp($bp-desktop-sm) {
            max-width: 460px;
        }

        @include bp($bp-desktop-md) {
            max-width: 625px;
        }
    }

    .promocode-step__desc {
        font-weight: 300;
        font-size: 14px;
        line-height: 24px;
        color: var(--primary-text);

        @include bp($bp-desktop-sm) {
            font-size: 16px;
            line-height: 26px;
        }
    }

    .promocode-step__number {
        position: absolute;
    }

    //
    // --mod
    //

    .promocode-step--1 {
        flex-direction: row-reverse;

        .promocode-step__text {
            margin-top: 20px;

            @include bp($bp-desktop-sm) {
                margin-top: 238px;
                margin-left: 95px;
                flex-direction: column;
            }
        }
        .promocode-step__desc {
            width: 214px;

            @include bp($bp-desktop-sm) {
                width: 223px;
            }
        }

        .promocode-step__number {
            top: -132px;
            left: 200px;
            max-width: 340px;

            @include bp($bp-desktop-sm) {
                top: -448px;
                left: 0;
                max-width: 755px;
            }
        }
    }

    .promocode-step--2 {
        .promocode-step__text {
            @include bp($bp-desktop-sm) {
                margin-top: 250px;
                margin-right: auto;
            }
        }

        .promocode-step__desc {
            width: 184px;
            margin-left: 130px;

            @include bp($bp-desktop-sm) {
                margin-left: 0;
                width: 294px;
            }
        }

        .promocode-step__number {
            top: -166px;
            left: -276px;
            max-width: 400px;

            @include bp($bp-desktop-sm) {
                top: -546px;
                left: -414px;
                max-width: 888px;
            }
        }
    }

    .promocode-step--3 {
        flex-direction: row-reverse;

        .promocode-step__text {
            @include bp($bp-desktop-sm) {
                margin-left: 200px;
            }
        }

        .promocode-step__desc {
            width: 222px;

            @include bp($bp-desktop-sm) {
                width: 212px;
            }
        }

        .promocode-step__number {
            top: -100px;
            left: 230px;
            max-width: 364px;

            @include bp($bp-desktop-sm) {
                top: -43px;
                left: -260px;
                max-width: 794px;
            }
        }
    }
</style>
